import * as Yup from 'yup';

export interface LoginForm {
  email: string;
  password: string;
}

export type LoginFormShape = {
  [key in keyof LoginForm]?: any;
};

export const schema = Yup.object().shape<LoginFormShape>({
  email: Yup.string().email('Digite um email válido, ex: joao@email.com').required('Digite um email'),
  password: Yup.string().required('Digite uma senha'),
});
